import { Teaser as t } from '@xprog/prensa/types'
import { TeaserRelated } from './TeaserRelated'

export const TeaserBackgroundRelated: t.TeaserProps = {
  className: 'TeaserBackgroundRelated',
  imageDerivative: '1x1',
  imageVariant: 'background',
  relatedLayout: TeaserRelated,
  subtitleVariant: 'newstitle-3xl',
  subjectVariant: 'filled',
  titleVariant: 'newstitle-6xl',
  css: {
    position: 'relative',
    mb: '$6',
    width: '100%',
    p: '$0',
    '.TeaserImage': {
      height: '780px',
    },
    '.TeaserImage img': {
      height: '680px',
      objectFit: 'cover'
    },
    '.TeaserRelated': {
      align: ['column', 'center', 'top'],
      backgroundColor: 'black',
      position: 'static',
      pt: '$0',
      pb: '$4',
      px: '$4',
      my: '$0',
      'div.Teaser': {
        mb: '$3',
      }
    },
    '.TeaserSubjectText': {
      color: '$basicWhite',
      fontSize: '16px',
      mb: '$4',
      textTransform: 'uppercase'
    },
    '.TeaserSubtitleText': {
      color: '$basicWhite',
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: 400,
      maxWidth: '720px',
      mb: '$4',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '.TeaserTitleText': {
      color: '$basicWhite',
      fontSize: '25px',
      letterSpacing: '0.2px',
      lineHeight: '30px',
      fontWeight: 600,
      maxWidth: '720px',
      mb: '$2',
      // px: '$6',
      textShadow: 'rgb(0 0 0 / 50%) 2px 2px 3px'
    },
    '> .TeaserWrap': {
      align: ['column', 'left', 'bottom'],
      aspectRatio: '3 / 1',
      background: 'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 60%)',
      position: 'absolute',
      height: '100%',
      width: '100%',
      '> .TeaserSubtitle': {
        px: '$4',
      },
      '> .TeaserSubject': {
        px: '$4',
      },
      '> .TeaserTitle': {
        px: '$4',
      },
    }
  }
}
